module.exports = __webpack_public_path__ + "img/envelope.fdff7aa2.svg";